// extracted by mini-css-extract-plugin
export default {"total":"Total_total__ct4qY"};